{
  "dss": {
    "footer": {
      "legalEntity": "STIHL VERTRIEBS AG, 8617 Mönchaltorf"
    },
    "link": {
      "contact": "https://support.stihl.com/de-CH/websso-contact/",
      "faq": "https://support.stihl.com/de-CH/externalkbsearchwebsso/"
    },
    "page": {
      "postPwSet": {
        "link_name": "Weiter zum Login",
        "link_url": "/user/ui/"
      }
    }
  }
}
